import React from 'react';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { LmsCertificateListFilterInput } from 'src/graphql/generated/graphql';
import { useCertificates } from 'src/hooks/query/lms/certificates/use-certificates';
import { useTable } from 'src/hooks/use-table';
import { LmsCertificatesTable } from './table/table';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { Filter } from './filter';
import { CreateEntityButton } from './create-certificate-button';

const PAGINATION_LIMIT = 10;

export const LmsCertificateList = () => {
  const { page, setPage, filter, onFilterChange, defaultFilter } = useTable<
    LmsCertificateListFilterInput,
    Record<any, any>
  >();

  const { loading, certificates, totalCount } = useCertificates({
    filter,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
  });

  return (
    <>
      <FilterWrapper>
        <Filter onSubmit={onFilterChange} defaultFilter={defaultFilter} />
      </FilterWrapper>

      <ContentWrapper>
        <TableWrapper>
          <div className="flex justify-end">
            <CreateEntityButton />
          </div>
          <LmsCertificatesTable
            data={certificates}
            className="mt-4"
            loading={loading}
            options={{
              page,
              count: totalCount,
              sort: true,
              rowsPerPage: PAGINATION_LIMIT,
              onChangePage: setPage,
              enableNestedDataAccess: '.',
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </>
  );
};
